import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import { CallModel } from '../models/CallModel';
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import { ServiceContractModel } from '../models/ServiceContractModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ServiceContractList  {
    items: ServiceContractModel[];
    loading: boolean;
}

export interface ServiceContractLoad { type: 'SERVICECONTRACT_LOAD', newState: ServiceContractList }
export interface ServiceContractLoading { type: 'SERVICECONTRACT_LOADING' }

export type KnownAction = ServiceContractLoad | ServiceContractLoading | ResetStore;

const initialCallListState: ServiceContractList = {
    items: [],
    loading: false
};

export const actionCreators = {
    loadServiceContract: (pSession: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState();          

        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;

        dispatch({ type: 'SERVICECONTRACT_LOADING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/ServiceContract?ServiceMaster=' + ServiceMasterNumber + '&CompanyCode=' + CompanyCode,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                const data: ServiceContractModel[] = container.data;
                    dispatch({ type: 'SERVICECONTRACT_LOAD', newState: { items: data, loading: false } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });

    }
};

export const reducer: Reducer<ServiceContractList> = (state: ServiceContractList | undefined, incomingAction: Action): ServiceContractList => {

    if (state === undefined) {
        return { ...initialCallListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'SERVICECONTRACT_LOADING':
            return { ...state, loading: true }
        case 'SERVICECONTRACT_LOAD':
            const loadHistoryAction = incomingAction as ServiceContractLoad;
            return { ...state, ...loadHistoryAction.newState, loading: false }
        case 'STORE_RESET':
            return { ...initialCallListState };
        default:
            return state;
    }
};